export const setAction = (data: {
  type: string;
  data: Record<string, unknown>;
}) => {
  localStorage.setItem('action', JSON.stringify(data));
};

export const getAction = <T>(): { type: string; data: T } | null => {
  const actionString = localStorage.getItem('action');

  if (!actionString) return null;

  try {
    return JSON.parse(actionString);
  } catch {
    return null;
  }
};

export const deleteAction = () => {
  localStorage.removeItem('action');
};
